import React from "react";
import { AlertTriangle } from "lucide-react";

// D20: micro taxpayers are warned, never blocked or hidden. One banner per
// screen — never repeated per row.
const MicroTaxpayerBanner = () => (
  <div role="note" aria-label="Micro taxpayer" className="mb-4 border border-warning-200 bg-warning-50 rounded-lg p-3 flex items-start gap-2">
    <AlertTriangle className="w-4 h-4 mt-0.5 text-warning-700" />
    <p className="text-sm text-warning-700">
      This client is a <span className="font-medium">micro taxpayer</span> (RR 8-2024). Expanded withholding is
      generally not required — records can still be saved.
    </p>
  </div>
);

export default MicroTaxpayerBanner;
